module.exports = __webpack_public_path__ + "static/media/select-arrow.e799d8a8.svg";